<template>
  <div class="mask" v-show="show">
    <div class="dialog">
      <div style="width: 100%;text-align: right;display: flex;justify-content: flex-end;">
        <div style="cursor: pointer;padding: 5px 10px" @click="closeShow">x</div>
      </div>
      <div style="margin-bottom: 8px;color: #35315C">扫码上传照片</div>
      <div v-show="!invalid" style="margin: 10px;padding: 8px;border: 1px solid gainsboro" ref="qrcode" id="qrcode"></div>
      <div @click="refresh" v-show="invalid" style="margin: 10px;padding: 8px;border: 1px solid gainsboro">
        <div style="width: 116px;height: 116px;background-color: #F5F6FA;display: flex;flex-direction: column;align-items: center;justify-content: center;cursor: pointer">
          <img style="width: 40px;margin-bottom: 10px" src="../assets/make/public/icon_refresh.png">
          <div style="width: 80%;font-size: 12px;color: rgba(53,49,92,0.4);text-align: center;zoom:0.9">
            当前二维码已失效请刷新重试
          </div>
        </div>
      </div>
      <div style="color: #35315C;font-size: 9px;margin: 20px 0 40px 0">手机上传照片时请不要关闭弹窗</div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "QRCodeDialog",
        props:['invalid','show'],
        watch:{
            show:function(newProps){

                if (newProps&&this.invalid){
                    this.refresh()
                }
            }
        },
        methods:{
            closeShow(){
                this.$emit('close', false)
            },
            refresh(){
                this.$emit('refresh')
            },
        }
    }
</script>

<style scoped>
  .mask{
    background-color: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
  }
  .dialog{
    width: 25%;
    background-color:white ;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;
  }
</style>
